<template>
    <div class="login-page">
        <div class="login-shell">
            <section class="brand-panel">
                <div class="brand-panel-inner">
                    <img
                        src="@/assets/icon/forgot-password.svg"
                        alt="Forgot password illustration"
                        class="brand-illustration"
                    />
                </div>
            </section>

            <section class="login-panel">
                <div class="login-card">
                    <div class="card-intro">
                        <h2 class="login-heading">Reset your password</h2>
                    </div>

                    <ValidationObserver ref="observer">
                        <div class="form-field">
                            <label class="field-label" for="emailaddress"
                                >Email Address</label
                            >
                            <ValidationProvider
                                rules="required|email"
                                v-slot="{ errors }"
                                name="email"
                            >
                                <div class="input-shell">
                                    <i
                                        class="fa fa-envelope-o input-icon"
                                        aria-hidden="true"
                                    ></i>
                                    <input
                                        id="emailaddress"
                                        v-model="email"
                                        type="email"
                                        class="login-input"
                                        autocomplete="email"
                                        placeholder="you@company.com"
                                        @keyup.enter="sendEmail"
                                    />
                                </div>
                                <span class="field-error" v-if="errors[0]">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>

                        <div class="form-field">
                            <label class="field-label">Account Type</label>
                            <div class="role-grid">
                                <button
                                    v-for="item in roleOptions"
                                    :key="item.value"
                                    type="button"
                                    class="role-card"
                                    :class="{
                                        'role-card--active':
                                            role === item.value,
                                    }"
                                    :aria-pressed="role === item.value"
                                    @click="selectRole(item.value)"
                                >
                                    <i
                                        :class="item.icon"
                                        aria-hidden="true"
                                    ></i>
                                    <span>{{ item.label }}</span>
                                </button>
                            </div>
                        </div>

                        <transition name="tenant-field">
                            <div v-if="showTenantField" class="form-field">
                                <label class="field-label" for="tenant"
                                    >Select Tenant</label
                                >
                                <eb-select
                                    id="tenant"
                                    type="text"
                                    class="login-select"
                                    v-model="selectedTenant"
                                    label="name"
                                    :options="tenantList"
                                    placeholder="Select tenant"
                                ></eb-select>
                            </div>
                        </transition>

                        <button class="sign-in-btn" @click.prevent="sendEmail">
                            Send OTP
                        </button>
                    </ValidationObserver>

                    <div class="forgot-link-wrapper">
                        <router-link to="/login" class="forgot-link">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                            Back to Sign In
                        </router-link>
                    </div>

                    <div class="panel-divider"></div>

                    <div class="powered-by powered-by--panel">
                        <span class="powered-label powered-label--panel"
                            >Powered by</span
                        >
                        <img
                            src="@/assets/icon/nipigeLogo.svg"
                            alt="Powered by Nipige"
                            class="powered-logo powered-logo--panel"
                        />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-select/dist/vue-select.css";
import { mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
    name: "RecoveryPassword",
    components: {
        ebSelect,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            email: "",
            role: "",
            selectedTenant: "",
        };
    },
    computed: {
        roleOptions() {
            return [
                { label: "Admin", value: "Admin", icon: "fa fa-shield" },
                { label: "Tenant", value: "Tenant", icon: "fa fa-home" },
                {
                    label: "Seller",
                    value: "Seller",
                    icon: "fa fa-shopping-cart",
                },
                { label: "Dealer", value: "Dealer", icon: "fa fa-users" },
                {
                    label: "Distributor",
                    value: "Distributor",
                    icon: "fa fa-truck",
                },
                {
                    label: "Manufacturer",
                    value: "Manufacturer",
                    icon: "fa fa-industry",
                },
            ];
        },
        tenantList() {
            let listdata = this.$store.getters["tenant/GetTenantLiteList"];
            listdata.map((object) => {
                object["name"] = object.company ? object.company.name : "";
            });
            return listdata;
        },
        showTenantField() {
            return (
                !!this.role && this.role !== "Admin" && this.role !== "Tenant"
            );
        },
    },
    mounted() {
        this.GetTenantList();
    },
    methods: {
        ...mapActions({
            GetTenantList: "tenant/fetchTenantsListLite",
        }),
        selectRole(role) {
            this.role = role;
            if (role === "Admin" || role === "Tenant") {
                this.selectedTenant = "";
            }
        },
        sendEmail() {
            if (this.role !== "Admin" && this.role !== "Tenant") {
                this.role = "Partner";
            }
            sessionStorage.setItem("userRole", this.role);
            if (this.role === "Partner") {
                sessionStorage.setItem("nipige:key", this.selectedTenant._id);
            }
            this.$store
                .dispatch("passwordReset/sendPasswordResetEmail", {
                    email: this.email,
                    userType: this.role,
                })
                .then((data) => {
                    this.$swal(data);
                    if (data.success) {
                        this.$router.push({ name: "resetpasswordemail" });
                    }
                });
        },
    },
};
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    padding: 0;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: "Plus Jakarta Sans", sans-serif;
    background: #ffffff;
}

.login-page::before,
.login-page::after {
    content: none;
}

.login-shell {
    width: 100%;
    min-height: 100vh;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(28rem, 39rem);
    position: relative;
    z-index: 1;
}

.brand-panel,
.login-panel {
    min-height: 100vh;
}

.brand-panel {
    position: relative;
    overflow: hidden;
    border-radius: 0;
    padding: clamp(2.5rem, 5vw, 4rem);
    background: linear-gradient(145deg, #eef4ff 0%, #e0ecff 50%, #ddeeff 100%);
}

.brand-panel::before {
    content: "";
    position: absolute;
    width: 22rem;
    height: 22rem;
    border-radius: 50%;
    top: -6rem;
    left: -6rem;
    background: radial-gradient(
        circle,
        rgba(46, 116, 255, 0.12),
        transparent 70%
    );
    pointer-events: none;
}

.brand-panel::after {
    content: "";
    position: absolute;
    width: 18rem;
    height: 18rem;
    border-radius: 50%;
    bottom: -5rem;
    right: -5rem;
    background: radial-gradient(
        circle,
        rgba(46, 116, 255, 0.1),
        transparent 70%
    );
    pointer-events: none;
}

.brand-panel-inner {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.brand-illustration {
    width: 100%;
    max-width: min(34rem, 80%);
    height: auto;
    object-fit: contain;
    user-select: none;
    pointer-events: none;
}

.login-panel {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border-radius: 0;
    padding: clamp(2rem, 5vw, 4rem);
    background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
}

.login-card {
    width: 100%;
    max-width: 34rem;
    padding-top: 9rem;
}

.card-intro {
    margin-bottom: 1.5rem;
    text-align: center;
}

.login-heading {
    margin: 0 0 0.6rem;
    color: #0f172a;
    font-size: clamp(1.7rem, 2.6vw, 2.2rem);
    font-weight: 700;
    line-height: 1.08;
    letter-spacing: -0.03em;
}

.form-field {
    margin-bottom: 1.1rem;
}

.tenant-field-enter-active,
.tenant-field-leave-active {
    transition:
        opacity 0.18s ease,
        transform 0.18s ease;
}

.tenant-field-enter,
.tenant-field-leave-to {
    opacity: 0;
    transform: translateY(-0.35rem);
}

.field-label {
    display: block;
    margin-bottom: 0.65rem;
    color: #31486b;
    font-size: 0.95rem;
    font-weight: 700;
}

.input-shell {
    position: relative;
    transition: transform 0.18s ease;
}

.input-shell:focus-within {
    transform: translateY(-1px);
}

.input-icon {
    position: absolute;
    top: 50%;
    left: 1.05rem;
    transform: translateY(-50%);
    color: #90a4c1;
    font-size: 1.05rem;
    pointer-events: none;
    transition: color 0.18s ease;
}

.input-shell:focus-within .input-icon {
    color: #2e74ff;
}

.login-input {
    width: 100%;
    height: 3.45rem;
    border-radius: 1rem;
    border: 1px solid #d7e1ee;
    background: #ffffff;
    color: #1e293b;
    font-size: 0.98rem;
    padding: 0.8rem 1rem 0.8rem 2.95rem;
    transition:
        border-color 0.18s ease,
        box-shadow 0.18s ease;
}

.login-input:-webkit-autofill,
.login-input:-webkit-autofill:hover,
.login-input:-webkit-autofill:focus,
.login-input:-webkit-autofill:active {
    -webkit-text-fill-color: #1e293b !important;
    caret-color: #1e293b;
    border: 1px solid #d7e1ee !important;
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
    box-shadow: 0 0 0 1000px #ffffff inset !important;
    background-color: #ffffff !important;
    transition: background-color 9999s ease-in-out 0s;
}

.login-input::placeholder {
    color: #7b8798;
}

.login-input:focus {
    outline: none;
    border-color: #2e74ff;
    box-shadow: 0 0 0 4px rgba(46, 116, 255, 0.12);
}

.field-error {
    display: block;
    margin-top: 0.35rem;
    color: #ef4444;
    font-size: 0.82rem;
}

.role-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
}

.role-card {
    min-height: 5.8rem;
    border: 1px solid #d7e1ee;
    border-radius: 1rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.55rem;
    color: #476181;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    padding: 0.75rem 0.6rem;
    transition:
        border-color 0.18s ease,
        box-shadow 0.18s ease,
        transform 0.18s ease,
        background-color 0.18s ease,
        color 0.18s ease;
}

.role-card i {
    font-size: 1.3rem;
    color: #9aacc6;
    transition: color 0.18s ease;
}

.role-card:not(.role-card--active):hover {
    border-color: #b9cbe4;
    transform: translateY(-1px);
    box-shadow: 0 18px 28px -24px rgba(15, 23, 42, 0.3);
}

.role-card:focus {
    outline: none;
}

.role-card:focus-visible {
    outline: none;
    border-color: #2e74ff;
    box-shadow: 0 0 0 4px rgba(46, 116, 255, 0.12);
}

.role-card--active {
    border-color: #2e74ff;
    background: rgba(46, 116, 255, 0.08);
    color: #1549cc;
    box-shadow: none;
    transform: none;
}

.role-card--active i {
    color: #2e74ff;
}

.sign-in-btn {
    width: 100%;
    height: 3.15rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 1rem;
    color: #ffffff;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    background: linear-gradient(135deg, #2e74ff 0%, #4583f3 100%);
    box-shadow: 0 18px 30px -20px rgba(15, 23, 42, 0.45);
    margin-top: 1.15rem;
    transition:
        transform 0.18s ease,
        box-shadow 0.18s ease,
        filter 0.18s ease;
}

.sign-in-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 22px 34px -22px rgba(15, 23, 42, 0.52);
    filter: saturate(1.05);
}

.forgot-link-wrapper {
    margin-top: 1rem;
    text-align: center;
}

.forgot-link {
    color: #2e74ff;
    font-size: 0.96rem;
    font-weight: 600;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
}

.forgot-link:hover {
    color: #155be5;
}

.panel-divider {
    margin-top: 1.35rem;
    border-top: 1px solid #e8eef7;
}

.powered-by {
    display: flex;
    align-items: center;
    gap: 0.85rem;
}

.powered-by--panel {
    margin-top: 1rem;
    flex-direction: column;
    justify-content: center;
}

.powered-label {
    font-size: 0.82rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.powered-label--panel {
    color: #c3cedb;
}

.powered-logo--panel {
    width: 11rem;
}

::v-deep .login-select.form-group {
    margin: 0;
    cursor: pointer;
}

::v-deep .login-select .v-select {
    color: #1e293b;
}

::v-deep .login-select .vs__dropdown-toggle {
    min-height: 3.45rem;
    border-radius: 1rem;
    border: 1px solid #d7e1ee;
    background: #ffffff;
    padding: 0 0.65rem;
    display: flex;
    align-items: center;
    transition:
        border-color 0.18s ease,
        box-shadow 0.18s ease;
}

::v-deep .login-select .vs__dropdown-toggle:hover {
    border-color: #b9cbe4;
}

::v-deep .login-select .vs__selected-options {
    display: flex;
    align-items: center;
    padding: 0 0.45rem 0 0.65rem;
}

::v-deep .login-select .vs__selected,
::v-deep .login-select .vs__search,
::v-deep .login-select .vs__search::placeholder {
    color: #476181;
    font-size: 0.98rem;
    opacity: 1;
}

::v-deep .login-select .vs__selected {
    margin: 0;
    padding: 0;
    line-height: 1.25;
}

::v-deep .login-select .vs__search {
    margin: 0;
    padding: 0;
    line-height: 1.25;
}

::v-deep .login-select .vs__actions {
    padding: 0 0.42rem 0 0.25rem;
}

::v-deep .login-select .vs__open-indicator {
    fill: #90a4c1;
}

::v-deep .login-select .vs--open .vs__dropdown-toggle {
    border-color: #2e74ff;
    box-shadow: 0 0 0 4px rgba(46, 116, 255, 0.12);
}

::v-deep .login-select .vs__dropdown-menu {
    margin-top: 0.55rem;
    border-radius: 1rem;
    border: 1px solid rgba(148, 163, 184, 0.22);
    background: #ffffff;
    box-shadow: 0 24px 38px -28px rgba(15, 23, 42, 0.45);
    overflow: hidden;
}

::v-deep .login-select .vs__dropdown-option {
    color: #334155;
    font-size: 0.95rem;
    padding: 0.65rem 0.9rem;
}

::v-deep .login-select .vs__dropdown-option--highlight {
    background: rgba(59, 130, 246, 0.1);
    color: #0f172a;
}

::v-deep .login-select .vs__dropdown-option--selected {
    background: rgba(59, 130, 246, 0.14);
    color: #0f172a;
}

@media (max-width: 1080px) {
    .login-page {
        min-height: 100vh;
    }

    .login-shell {
        grid-template-columns: 1fr;
    }

    .brand-panel,
    .login-panel {
        min-height: auto;
    }

    .brand-panel {
        min-height: 34vh;
        padding: 2rem 1.5rem;
    }

    .login-panel {
        padding: 2rem 1.5rem 2.5rem;
    }

    .brand-illustration {
        max-width: 18rem;
    }
}

@media (max-width: 767.98px) {
    .login-page {
        min-height: 100vh;
    }

    .brand-panel {
        display: none;
    }

    .login-panel {
        padding: 1.5rem 1rem 2rem;
    }

    .login-card {
        max-width: none;
        padding-top: 3rem;
    }

    .login-heading {
        font-size: 1.65rem;
    }

    .role-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .role-card {
        min-height: 5.2rem;
        font-size: 0.86rem;
    }

    .login-input,
    ::v-deep .login-select .vs__dropdown-toggle {
        min-height: 3.05rem;
        height: 3.05rem;
        font-size: 0.94rem;
        border-radius: 0.9rem;
    }

    .login-input {
        padding: 0.7rem 0.95rem 0.7rem 2.7rem;
    }

    .sign-in-btn {
        height: 3rem;
        border-radius: 0.9rem;
    }
}

@media (max-width: 420px) {
    .login-panel {
        padding: 1rem;
    }

    .login-card {
        padding-top: 2.25rem;
    }

    .role-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.65rem;
    }

    .role-card {
        min-height: 5rem;
        font-size: 0.85rem;
        padding: 0.75rem 0.55rem;
    }
}

@media (max-height: 920px) and (min-width: 768px) {
    .login-page {
        min-height: 100vh;
    }

    .brand-panel,
    .login-panel {
        min-height: 100vh;
    }

    .login-panel {
        padding: 1.75rem 2rem;
    }

    .login-card {
        padding-top: 5.5rem;
    }

    .card-intro {
        margin-bottom: 1.15rem;
    }

    .login-heading {
        font-size: 1.8rem;
    }

    .form-field {
        margin-bottom: 0.9rem;
    }

    .role-card {
        min-height: 5.15rem;
        font-size: 0.86rem;
    }

    .sign-in-btn {
        height: 2.95rem;
        margin-top: 0.95rem;
    }

    .panel-divider {
        margin-top: 1.1rem;
    }

    .powered-by--panel {
        margin-top: 0.9rem;
    }
}
</style>
